<div class="date-picker">
  <div class="date-now date-control mr-3" *ngIf="allowNow">
    <button type="button" class="radio btn btn-sm" [class.selected]="stateNow"
      [disabled]="disabled" (click)="onSetNow(true)"></button>
    <div class="title">Public Now</div>
  </div>
  <div class="date-select date-control">
    <button type="button" class="radio btn btn-sm" [class.selected]="!stateNow"
      [disabled]="disabled" (click)="onSetNow(false)" *ngIf="allowNow"></button>
    <div class="date-picker">
      <input type="text" class="form-control border-0" #dp="bsDatepicker" value="{{ selectedDate | date: 'MM/dd/yy' }}"
        bsDatepicker placeholder="mm/dd/yy" [(ngModel)]="selectedDate" [disabled]="isDisabled()" (bsValueChange)="onSetDate($event)">
      <button type="button" class="radio btn btn-sm p-0" [disabled]="isDisabled()" (click)="dp.toggle()">
        <i class="icon icon-calendar" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</div>